import React from 'react';
import { aboutUs } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-[#faf8f5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left Content */}
          <div>
            <span className="text-xs tracking-[0.3em] uppercase text-[#c9b896] mb-4 block">
              Who We Are
            </span>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#2c2825] mb-8" style={{ fontWeight: 400 }}>
              {aboutUs.title}
            </h2>
            <div className="w-16 h-px bg-[#c9b896] mb-8" />
          </div>

          {/* Right Content */}
          <div className="space-y-6">
            <p className="text-base lg:text-lg text-[#5a5652] leading-relaxed">
              {aboutUs.description}
            </p>
            <p className="text-base lg:text-lg text-[#5a5652] leading-relaxed">
              {aboutUs.values}
            </p>
            <p className="font-display text-xl lg:text-2xl text-[#2c2825] italic mt-8" style={{ fontWeight: 400 }}>
              {aboutUs.mission}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
